import React from "react";
import {
  FaCube,
  FaProjectDiagram,
  FaServer,
  FaCode,
  FaExchangeAlt,
  FaWallet,
  FaComments,
} from "react-icons/fa";

function CustomBlockchain() {
  return (
    <>
      <div className="team-single-area default-padding">
        <div className="container">
          <div className="team-single-items">
            <div className="row">
              <div className="col-lg-5 left-info">
                <div className="thumb fade-up-anim">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/5.jpg"
                    alt="Thumb"
                  />
                </div>
              </div>

              <div className="col-lg-7 right-info pl-30 pl-md-15 pl-xs-15">
                <div className="container">
                  <div className="col-lg-12">
                    <div className="site-heading">
                      <h4 className="sub-title">Our Services</h4>
                      <h2 className="title split-text-right split-text-in-right split-lines">
                        Our Cosmos SDK Development Services
                      </h2>
                    </div>
                  </div>
                </div>

                <div className="container">
                  <div className="services-style-four-items">
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaCube size={35} />
                      </div>
                      <h4>Custom Blockchain Development</h4>
                      <p>
                        Xeer Technology offers end-to-end Cosmos SDK blockchain
                        development services, enabling businesses to build
                        custom blockchains optimized for security, speed, and
                        scalability.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaProjectDiagram size={35} />
                      </div>
                      <h4>Interoperability Solutions</h4>
                      <p>
                        Implementing the Inter-Blockchain Communication (IBC)
                        protocol for seamless integration with other Cosmos
                        networks.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaServer size={35} />
                      </div>
                      <h4>Validator Node Setup & Management</h4>
                      <p>
                        Reliable validator node setup and monitoring to ensure
                        high uptime and network performance.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaCode size={35} />
                      </div>
                      <h4>Smart Contract Development</h4>
                      <p>
                        Design and deploy secure smart contracts tailored to
                        automate workflows using Cosmos SDK.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaExchangeAlt size={35} />
                      </div>
                      <h4>Cross-Chain Bridge Development</h4>
                      <p>
                        Build secure bridges for asset transfer and data
                        exchange across blockchains.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaWallet size={35} />
                      </div>
                      <h4>Wallet Development</h4>
                      <p>
                        Design secure, user-friendly digital wallets compatible
                        with Cosmos and Tendermint chains.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaComments size={35} />
                      </div>
                      <h4>Cosmos SDK Consultation</h4>
                      <p>
                        Consulting services for architecture, security, and
                        performance optimization of your blockchain project.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CustomBlockchain;
